"use client";
async function i(r, s, o, n, a) {
  const t = await fetch(r, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...n
    },
    signal: a,
    body: JSON.stringify({
      query: s,
      variables: o
    })
  });
  if (!t.ok)
    throw new Error(`Network response was not OK (status: ${t.status})`);
  const e = await t.json();
  if (e.errors?.length)
    throw new Error(e.errors[0].message);
  return e.data;
}
export {
  i as graphqlRequest
};
